import React, { useEffect } from "react";
import "./Certifications.css";
import { FaCertificate, FaCheckCircle } from "react-icons/fa";

const Certifications = () => {
  const certifications = [
    {
      id: 1,
      name: "Machine Learning Specialization",
      issuer: "Stanford University",
      date: "2024",
      skills: ["Machine Learning", "Deep Learning", "Neural Networks"],
    },
    {
      id: 2,
      name: "AWS Certified Solutions Architect",
      issuer: "Amazon Web Services",
      date: "2023",
      skills: ["AWS", "Cloud Computing", "Architecture Design"],
    },
    {
      id: 3,
      name: "Google IT Support Professional",
      issuer: "Google",
      date: "2023",
      skills: ["IT Support", "Networking", "System Administration"],
    },
    {
      id: 4,
      name: "Data Science Professional Certificate",
      issuer: "IBM",
      date: "2023",
      skills: ["Python", "Data Analysis", "Machine Learning"],
    },
    {
      id: 5,
      name: "React Developer Certification",
      issuer: "Meta",
      date: "2024",
      skills: ["React", "JavaScript", "Frontend Development"],
    },
    {
      id: 6,
      name: "Cybersecurity Fundamentals",
      issuer: "Cisco",
      date: "2023",
      skills: ["Network Security", "Cybersecurity", "Risk Management"],
    },
  ];

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
          }
        });
      },
      { threshold: 0.1 }
    );

    document.querySelectorAll(".cert-card").forEach((el) => {
      observer.observe(el);
    });

    return () => observer.disconnect();
  }, []);

  return (
    <section className="certifications">
      <div className="certifications-container">
        <div className="section-header">
          <span className="badge">📜 Certifications</span>
          <h1>My Certifications</h1>
          <p>Professional certifications and specialized training</p>
        </div>

        <div className="cert-grid">
          {certifications.map((cert, index) => (
            <div 
              className="cert-card" 
              key={cert.id}
              style={{ animationDelay: `${index * 0.1}s` }}
            >
              <div className="cert-icon-wrapper">
                <FaCertificate />
              </div>
              <h3>{cert.name}</h3>
              <p className="cert-issuer">{cert.issuer}</p>
              <div className="cert-date">
                <span>📅 {cert.date}</span>
              </div>
              <div className="cert-skills">
                {cert.skills.map((skill, idx) => (
                  <span className="cert-skill" key={idx}>
                    <FaCheckCircle /> {skill}
                  </span>
                ))}
              </div>
              <div className="cert-verified">
                <span>✅ Verified</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Certifications;